// material-ui
import { Button, Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';

// hooks
import useAuth from 'hooks/useAuth';

const LogoutDialog = () => {
  const { logoutDialog, setLogoutDialog, logout } = useAuth();

  const handleClose = () => {
    setLogoutDialog(!logoutDialog);
  };

  const handleLogout = () => {
    logout();
    setLogoutDialog(!logoutDialog);
  };

  return (
    <Dialog open={logoutDialog}>
      <Stack spacing={3} sx={{ p: 4 }}>
        <Typography variant="subtitle1" align="center">
          ログアウトしますか？
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            color="info"
            variant="contained"
            sx={{
              width: 130,
              height: 35,
              p: 1,
              textAlign: 'center',
              borderRadius: 17,
              boxShadow: 'none'
            }}
            onClick={handleClose}
          >
            <Typography variant="subtitle1" sx={{ color: '#444444' }}>
              キャンセル
            </Typography>
          </Button>
          <Button
            color="warning"
            variant="contained"
            sx={{
              width: 130,
              height: 35,
              p: 1,
              textAlign: 'center',
              borderRadius: 17,
              boxShadow: 'none'
            }}
            onClick={handleLogout}
          >
            <Typography variant="subtitle1" color="success">
              ログアウト
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default LogoutDialog;
